import React from "react";
import { Reveal, Overline, MaskLine } from "./Motion";
import { SmartImage } from "./SmartImage";
import { VERIFIED } from "@/data/cafe";

const chapters = [
  { n: "01", title: "The Bean", text: "We source single-origin beans from ethical growers, then roast in small batches for a cup that tastes of its terroir." },
  { n: "02", title: "The Craft", text: "Every drink is pulled, poured, and finished by hand — from the first espresso at dawn to the last cold brew at night." },
  { n: "03", title: "The Space", text: "Warm wood, soft light, free Wi-Fi and quiet corners. A room built for coffee lovers, families, and friends to unwind." },
];

export default function About() {
  return (
    <section id="about" className="bg-[#F5F2EB] py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Overline>About Us</Overline>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A1514] mt-4 font-medium leading-[1.05]">
              <MaskLine>Every cup creates a</MaskLine>
              <MaskLine delay={0.1}><span className="italic text-[#1C7C54]">memorable experience.</span></MaskLine>
            </h2>
            <Reveal delay={0.15}>
              <p className="font-body text-[#1A1514]/70 text-lg leading-relaxed mt-8 max-w-2xl">
                At Teaavi Coffee, we believe every cup creates a memorable experience. From freshly brewed coffee and
                artisan teas to handcrafted desserts and delicious meals, our café is designed for coffee lovers,
                families, professionals, and friends to relax and connect.
              </p>
            </Reveal>

            <div className="mt-14 space-y-px border-t border-[#1A1514]/10">
              {chapters.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.08}>
                  <div className="grid grid-cols-12 gap-4 py-7 border-b border-[#1A1514]/10 group">
                    <span className="col-span-2 font-display text-3xl text-[#1C7C54]">{c.n}</span>
                    <div className="col-span-10">
                      <h3 className="font-display text-2xl text-[#1A1514] group-hover:translate-x-1 transition-transform duration-300">{c.title}</h3>
                      <p className="font-body text-[#1A1514]/60 mt-2 leading-relaxed">{c.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <Reveal className="relative">
              <div className="overflow-hidden rounded-sm">
                <SmartImage src={VERIFIED.interior1} alt="Teaavi café interior" className="w-full h-[420px] lg:h-[600px] object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-[#1A1514] text-[#F5F2EB] px-8 py-6 rounded-sm hidden md:block">
                <p className="font-display text-4xl leading-none">7AM</p>
                <p className="overline text-[#1C7C54] mt-1">Open Daily</p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
